<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M4.999999940395355,2.66C4.999999940395355,4.14,7.999999940395355,8,7.999999940395355,8C7.999999940395355,8,10.999999940395355,4.14,10.999999940395355,2.66C10.989999940395355,1.2,9.659999940395355,0,7.999999940395355,0C6.339999940395355,0,4.999999940395355,1.2,4.999999940395355,2.66ZM6.999999940395355,3C6.999999940395355,2.45,7.449999940395355,2,7.999999940395355,2C8.549999940395356,2,8.999999940395355,2.45,8.999999940395355,3C8.999999940395355,3.55,8.549999940395356,4,7.999999940395355,4C7.449999940395355,4,6.999999940395355,3.55,6.999999940395355,3ZM14.999999940395355,10C14.999999940395355,9.45,14.549999940395356,9,13.999999940395355,9L1.9999999403953552,9C1.4499999403953552,9,0.9999999403953552,9.45,0.9999999403953552,10L0.9999999403953552,15C0.9999999403953552,15.55,1.4499999403953552,16,1.9999999403953552,16L13.999999940395355,16C14.549999940395356,16,14.999999940395355,15.55,14.999999940395355,15L14.999999940395355,10ZM5.999999940395355,10L5.999999940395355,15L6.999999940395355,15L6.999999940395355,10L5.999999940395355,10ZM8.499999940395355,10L10.999999940395355,10L10.999999940395355,13L8.999999940395355,13L8.999999940395355,15L7.999999940395355,15L7.999999940395355,10L8.499999940395355,10ZM8.999999940395355,11L8.999999940395355,12L9.999999940395355,12L9.999999940395355,11L8.999999940395355,11Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'IpAddress',
} as DefineComponent
</script>
